$(function () {
  $(document).ready(function () {
    var body = $('body');

    function hidePopup(elem) {
     
      elem.animate({'bottom': '-2000px', 'visibility': 'hidden', 'position': 'absolute'}, 500, function(){
        $(this).removeClass('visible').addClass('invisible');   
      });
      if (body.hasClass('no-scroll')) {body.removeClass('no-scroll');}
    }

    var addOns = $('.features-popup-target');
    addOns.each(function () {
      var infoDataTarget = $(this).attr('data-target');
     
      if (infoDataTarget) {
        $(this).on('click', function (e) {

          e.stopPropagation();
          var popups = $('.hidden');
          popups.each(function () {
            var elemID = $(this).attr('id');
            if (elemID && elemID === infoDataTarget) {
              if ($(this).hasClass('visible')) { // Close popup
               
                hidePopup($(this));
                
              } else { // Open popup
                if ($(this).siblings('.visible').length) {
                 
                  hidePopup($(this).siblings())
                }
               
                $(this).animate({'bottom': '0px', 'visibility': 'visible', 'position': 'fixed'}, 700).addClass('visible').removeClass('invisible');
                if ($(window).width() < 992) {
                  body.addClass('no-scroll');
                }
              }
            }
          });

          // Close popup on close button click
          var visiblePopup = $('.hidden.visible');
          if (visiblePopup) {
            var closeBtn = visiblePopup.find('.feature-popup-close');
            closeBtn.on('click', function (e) {
             
              e.stopPropagation();
              hidePopup(visiblePopup);
              body.removeClass('no-scroll');
            });

            $(document).click(function (e) {
             
              if (!$(e.target).is(infoDataTarget)) {
                if (visiblePopup) {
                  hidePopup(visiblePopup);
                }
              }
            });
          }
        });
      }
    });
  });
});



// WEBPACK FOOTER //
// ./scripts/routes/slideinpopup.js